import script from "./HomepageAllezchantez.vue?vue&type=script&setup=true&lang=js"
export * from "./HomepageAllezchantez.vue?vue&type=script&setup=true&lang=js"

import "./HomepageAllezchantez.vue?vue&type=style&index=0&id=d0bbaf10&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0bbaf10"]])

export default __exports__